import { render, staticRenderFns } from "./tipconNav.vue?vue&type=template&id=53bfec14&scoped=true&"
import script from "./tipconNav.vue?vue&type=script&lang=js&"
export * from "./tipconNav.vue?vue&type=script&lang=js&"
import style0 from "./tipconNav.vue?vue&type=style&index=0&id=53bfec14&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bfec14",
  null
  
)

export default component.exports